module.exports = __webpack_public_path__ + "img/img_aboutus_01.342936d8.png";